export enum NEW_RECIPIENT_FIELD_NAMES {
  Email = "email",
  FileFormat = "fileFormat",
}
